import getLocalizedStrings from "owa-localize/lib/getLocalizedStrings";
import { format } from "owa-localize/lib/utilities/format";
import type { ResourceId } from "owa-localize";
import { outlookDataFileFmt } from "./getPstDisplayName.locstring.json";

// win32gql's mountPst API can return a mounted PST file with the hardcoded English display name "Outlook Data File".
// To provide a better localized experience, we replace the display name with the localized version of "Outlook Data File (file_name)".
export function getPstDisplayName(displayName: string, filePath: string): string {
    if (displayName === "Outlook Data File") {
        const fileNameWithExtension = filePath.split(/[\\/]/).pop();
        if (fileNameWithExtension) {
            const lastDotIndex = fileNameWithExtension.lastIndexOf(".");
            const fileName = lastDotIndex > 0
                ? fileNameWithExtension.slice(0, lastDotIndex)
                : fileNameWithExtension;
            
            // Call getLocalizedStrings and format instead of loc() because this file is in the native bundle, so we import
            // from owa-localize sub-paths to avoid the barrel export's orchestrator registration which pulls in the Analytics bundle.
            const locString = getLocalizedStrings().get(outlookDataFileFmt as unknown as ResourceId);
            return locString ? format(locString, fileName) : `${displayName} (${fileName})`;
        }
    }
    return displayName;
}
